import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/subscriptions/plans.ts
import { Exception } from "@wbk/logger";
var getSubscriptionPlans = (_0) => __async(void 0, [_0], function* ({ subscriptionSlug, lang }) {
  try {
    const url = `/subscriptions/${subscriptionSlug}/plans?lang=${lang}`;
    const data = yield fetchClient({ url, includeAuth: false });
    const sub = data.data;
    if (!sub) {
      throw new Error(`Subscription "${subscriptionSlug}" not found`);
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getSubscriptionPlansException",
      context: { tags: { journey: "subscribe" }, extra: { subscriptionSlug } }
    });
  }
});

export {
  getSubscriptionPlans
};
//# sourceMappingURL=chunk-JMB4EYSN.mjs.map